import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
class EdButton extends Vue {

  @Prop() readonly mode: string;
  @Prop() readonly disabled: string;
  @Prop() readonly color: string;
  @Prop() readonly isProcessing: boolean;
  @Prop({ default: false }) readonly isFit: boolean;
  @Prop() readonly name: string;
  
  public readonly clickButton: string = 'clickButton';

  get isOutline() {
    return this.mode == 'outline';
  }

  get processingColor() {
    return this.isOutline ? '#2BB2AC' : 'white';
  }
  
  get classes() {
    return { 
      'ed-button--disabled': this.disabled,
      'ed-button--enabled': !this.disabled,
      'ed-button--processing': this.isProcessing,
      'ed-button--fit-width': this.isFit,
    }
  }

  get automationTag() {
    return {[`auto-button-${this.name}`]: ''}
  }

  action() {
    if(!this.disabled) {
      this.$emit(this.clickButton);
    }
  }

}

export default Vue.component('ed-button', EdButton);

